import {UmpireSquad} from '@tisa-group/models';

export interface SeasonTableDataModel {
  draw: string;
  goals_against: string;
  goals_diff: string;
  goals_for: string;
  last_five_matches: string[];
  lost: string;
  matches_played: string;
  points: string;
  position: string;
  squad: UmpireSquad | undefined;
  won: string;
  promotion: SeasonTablePromotionType | undefined;
}

export enum SeasonTablePromotionType {
  UCL = 'ucl', // Champions league
  UECL = 'uecl', // Conference league
  UEL = 'uel', // Europa league
  DROP = 'drop',
}
